import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import MultiSelectTypeahead from "../../components/MultiselectTypeahead";
import { DataListType } from "../../components/AsyncTypeahead";
import { api, apiClient, apiTaskClient } from "../../api";
import { TaskPriority } from "tasks-experience-client";

const FilterModal = (props: any) => {
  const [patientsList, setPatientsList] = useState<DataListType[]>([]);
  const [assigneeList, setAssigneeList] = useState<DataListType[]>([]);
  const [selectedPatients, setSelectedPatients] = useState<string[] | number[]>(
    []
  );
  const [selectedAssignee, setSelectedAssignee] = useState<string[] | number[]>(
    []
  );
  const [filterForm, setFilterForm] = useState({
    priority: "",
    taskType: "",
  });

  const [priority, setPriority] = useState<TaskPriority[]>([]);
  const loadPatients = async (query: string) => {
    if (!query) {
      setPatientsList([]);
      return;
    }
    try {
      const data = await api.getPatients({ name: query });
      const options: DataListType[] = data.map((item: any) => ({
        key: item.patientId,
        value: `${item.firstName} ${item.lastName}`,
      }));
      setPatientsList(options);
    } catch (error: any) {
      console.log(error);
    }
  };

  const selectPatients = (items: DataListType[]) => {
    const data = items.map((item: DataListType) => item.key);
    console.log(data);
    setSelectedPatients([...data]);
  };
  const selectAssignees = (items: DataListType[]) => {
    const data = items.map((item: DataListType) => item.key);
    setSelectedAssignee([...data]);
  };
  const loadAssignee = async (query: string) => {
    if (!query) {
      setAssigneeList([]);
      return;
    }
    try {
      const data = await api.getCoaches({ name: query });
      console.log("data", data);
      const options: DataListType[] = data.map((item: any) => ({
        key: item.id,
        value: `${item.firstName} ${item.lastName}`,
      }));
      setAssigneeList(options);
    } catch (error: any) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTaskPriority();
  }, []);

  const getTaskPriority = async () => {
    try {
      // (await apiTaskClient.tasksControllerGetTaskPriorityList())
      //   .json()
      //   .then((data: TaskPriority[]) => {
      //     setPriority(data);
      //   });
    } catch (error) {
      console.log(error);
    }
  };

  // const formChangeHandlar = (event: any) => {
  //     const value = event.target.value;
  //     const newState = {
  //         ...filterForm,
  //         [event.target.name]: value,
  //     };
  //     setFilterForm(newState);
  // };

  const applyTaskFilter = () => {
    const data = {
      patients: selectedPatients,
      assignee: selectedAssignee,
      priority: filterForm.priority,
    };
    props.updateFilter({ ...data });
    props.setModalShow(false);
  };

  return (
    <>
      <Modal
        show={props.modalShow}
        onHide={() => props.setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-3">
            <div className="col-6">
              <label
                htmlFor="patient"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Add Patient
              </label>
              <MultiSelectTypeahead
                options={patientsList}
                callback={loadPatients}
                setSelectedItems={selectPatients}
              ></MultiSelectTypeahead>
            </div>
            <div className="col-6">
              <label
                htmlFor="assignee"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Assignee
              </label>
              <MultiSelectTypeahead
                options={assigneeList}
                callback={loadAssignee}
                setSelectedItems={selectAssignees}
              ></MultiSelectTypeahead>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <button
            type="button"
            className="btn btn-outline-secondary rounded-pill px-6 my-0"
            onClick={() => props.setModalShow(false)}
          >
            Discard
          </button>
          <button
            type="button"
            className="btn btn-secondary rounded-pill px-6 my-0"
            onClick={applyTaskFilter}
          >
            Apply
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FilterModal;
